import React from 'react';
import { motion } from 'framer-motion';

const Timeline = ({ children, className = '' }) => {
  return (
    <div className={`relative ${className}`}>
      {/* Vertical line */}
      <div className="absolute left-0 md:left-1/2 transform md:-translate-x-1/2 h-full w-0.5 bg-gradient-to-b from-primary-500 via-secondary-500 to-primary-500" />
      <div className="space-y-12">{children}</div>
    </div>
  );
};

export const TimelineItem = ({
  children,
  position = 'left',
  icon,
  date,
  className = '',
  index = 0,
}) => {
  const isLeft = position === 'left' || index % 2 === 0;

  return (
    <motion.div
      className={`relative flex items-center ${className}`}
      initial={{ opacity: 0, x: isLeft ? -50 : 50 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      {/* Desktop layout */}
      <div className="hidden md:flex w-full items-center">
        {/* Left content */}
        <div className={`w-5/12 ${isLeft ? 'pr-8 text-right' : ''}`}>
          {isLeft && children}
        </div>

        {/* Center dot */}
        <div className="w-2/12 flex justify-center">
          <div className="relative">
            <motion.div
              className="w-4 h-4 bg-primary-500 rounded-full border-4 border-white shadow-lg z-10 relative"
              whileHover={{ scale: 1.2 }}
            />
            {icon && (
              <div className="absolute -top-1 -left-1 w-6 h-6 bg-primary-100 rounded-full flex items-center justify-center">
                {icon}
              </div>
            )}
          </div>
        </div>

        {/* Right content */}
        <div className={`w-5/12 ${!isLeft ? 'pl-8' : ''}`}>
          {!isLeft && children}
        </div>
      </div>

      {/* Mobile layout */}
      <div className="md:hidden flex w-full">
        <div className="w-8 flex-shrink-0 flex justify-center">
          <motion.div
            className="w-3 h-3 bg-primary-500 rounded-full border-2 border-white shadow-lg z-10 relative"
            whileHover={{ scale: 1.2 }}
          />
        </div>
        <div className="flex-1 pl-4">{children}</div>
      </div>
    </motion.div>
  );
};

export const TimelineContent = ({ children, className = '' }) => (
  <div className={`bg-white rounded-xl shadow-soft p-6 ${className}`}>
    {children}
  </div>
);

export default Timeline;
